import { TableHeader } from '@/components/ui/table';

export function ThroughputTotalHeader() {
  return (
    <TableHeader narrow className="text-left align-bottom">
      Total Throughput
    </TableHeader>
  );
}
